export const APPLY_FREE_TRIAL = 'APPLY_FREE_TRIAL'
export const APPLY_FREE_TRIAL_IN_PROGRESS = 'APPLY_FREE_TRIAL_IN_PROGRESS'
export const APPLY_FREE_TRIAL_SUCCEEDED = 'APPLY_FREE_TRIAL_SUCCEEDED'
export const APPLY_FREE_TRIAL_FAILED = 'APPLY_FREE_TRIAL_FAILED'

export function applyForFreeTrial(details, source, sourceDetails, contact, customerName) {
    return { type: APPLY_FREE_TRIAL, payload: { details, source, sourceDetails, contact, customerName } }
}
